'use client'

import { useEffect, useRef } from 'react'

interface VideoBackgroundProps {
  videoSrc: string
  overlayColor?: string
  fixed?: boolean
}

export default function VideoBackground({ 
  videoSrc, 
  overlayColor = '', // Sin overlay por defecto para colores vivos
  fixed = true 
}: VideoBackgroundProps) {
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    // Asegurar que el video se reproduzca automáticamente
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.log('Autoplay prevented:', error)
        // Fallback: intentar reproducir con interacción del usuario
        const playOnInteraction = () => {
          if (videoRef.current) {
            videoRef.current.play()
          }
          document.removeEventListener('click', playOnInteraction)
          document.removeEventListener('touchstart', playOnInteraction)
        }
        document.addEventListener('click', playOnInteraction)
        document.addEventListener('touchstart', playOnInteraction)
      })
    }
  }, [])

  return (
    <div className={`${fixed ? 'fixed' : 'absolute'} inset-0 z-0 overflow-hidden bg-black`}>
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        className={`${fixed ? 'fixed' : 'absolute'} top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-auto h-[100vh] max-w-none opacity-70`}
        style={{ height: fixed ? '100vh' : '100%', width: 'auto' }}
        preload="auto"
      >
        <source src={videoSrc} type="video/mp4" />
        Tu navegador no soporta videos HTML5.
      </video>
      {overlayColor || (
        <div className={`${fixed ? 'fixed' : 'absolute'} inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black`}></div>
      )}
    </div>
  )
}